import { Moment } from '~/types';
import { time } from '~/utils';

const getDateFromDayNumber = (day: number = 1): Moment => {
  const year = time().year();
  return time(`${year}-01-01`).add(day - 1, 'day');
};

export default getDateFromDayNumber;
